import React, { useState } from "react";
import styles from "./PlatformCheckboxList.module.css";
import PropTypes from "prop-types";
import PlatformCheckbox from "../PlatformCheckbox";

/**
 * Interactive component. Checklist of compatible platforms.
 */
export function PlatformCheckboxList({
  checkedPlatforms = [], // Add safeguard for 'undefined',
  setCheckedPlatforms,
}) {
  // console.log("Full checkedPlatforms:", checkedPlatforms);
  
  // Map UI-friendly labels
  const platformMap = {
    Web: "PC",
    iOS: "Apple",
    Android: "Android",
  };

  const platformTypes = ["Web", "iOS", "Android"];

  // const handleCheckedPlatform = (platformType) => {
  //   setCheckedPlatforms({
  //     ...checkedPlatforms,
  //     [platformType]: !checkedPlatforms[platformType],
  //   });
  // };

  const handleOnChange = (platformType) => {
    setCheckedPlatforms(platformType);
  };

  return (
    <div className={styles.container}>
      <h5 className={styles.label}>Platforms</h5>

      <div className={styles.platform}>
        {platformTypes.map((platformType, index) => (
          <PlatformCheckbox
            key={index}
            platformType={platformMap[platformType]} // Update to use new platformMap
            isIncompatible={checkedPlatforms.includes(platformMap[platformType])} // Same as above
            setIncompatiblePlatforms={() => handleOnChange(platformType)}
          />
        ))}
      </div>
    </div>
  );
}

PlatformCheckboxList.propTypes = {
  /**
   * An array of the currently checked platforms. Defaults to all platforms as checked.
   */
  checkedPlatforms: PropTypes.arrayOf(
    PropTypes.oneOf(["PC", "Apple", "Android"])
  ),

  /**
   * Sets the value of checkedPlatforms.
   */
  setCheckedPlatforms: PropTypes.func,
};
